import { ProgressBar } from "react-bootstrap";

interface WizardProgressProps {
  steps: string[];
  currentStep: number;
}

function WizardProgress({ steps, currentStep }: WizardProgressProps) {
  const progress = ((currentStep + 1) / steps.length) * 100;

  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between mb-2">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`text-center flex-fill ${
              index === currentStep
                ? "fw-bold text-primary"
                : index < currentStep
                  ? "text-success"
                  : "text-muted"
            }`}
            style={{ fontSize: "0.9rem" }}
          >
            {step}
          </div>
        ))}
      </div>
      <ProgressBar
        now={progress}
        variant={currentStep === steps.length - 1 ? "success" : "primary"}
      />
      <div
        className="text-center text-muted mt-2"
        style={{ fontSize: "0.85rem" }}
      >
        Step {currentStep + 1} of {steps.length}
      </div>
    </div>
  );
}

export default WizardProgress;
